export enum TemplateAttributeDataType {
  Number = 1,
  Text = 2,
  DateTime = 3,
  Boolean = 4,
  Lookup = 5,
  Table = 6,
  MultilineText = 7,
}
